/**
 * Created by Mark on 17/04/2017.
 */

import Curriculum from './curriculum.js';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import Image from '../components/media/image.js';
import InternationalizationStore from '../store/internationalization-store.js';
class Language {

    constructor(name , ietf  , isInterface , translation , hasSpeaking){
        this.name = name;
        this.translationID = translation;
        this.ietf = ietf;
        this.hasSpeaking = Number(hasSpeaking);
        this.curriculums = {};
        this.isInterface = isInterface;
    }

    getName(){
        return InternationalizationStore.getTranslation("ui-"+this.name , this.name);
    }

    addCurriculum(uid , packageID , curriculum_name){

        console.log(uid);
        this.curriculums[uid] = new Curriculum(uid , packageID , curriculum_name);
    }

    getCurriculums(){
        return Object.keys(this.curriculums).map(function(k) { return this.curriculums[k] }.bind(this));
    }

    belongsToMultipleCurriculums(){
        return Object.keys(this.curriculums).length > 1;
    }

    fetchCurriculums(){
        //
    }

}

export default Language;


// WEBPACK FOOTER //
// ./src/classes/language.js